module.exports = __webpack_public_path__ + "static/gruumsh-symbol-DND3_FnP-87d368dd4f54b5e1d6a48b7776465582.jpg";